export const initialState = {
    currentIndex: -1,
    isAnimDirectionForward: true,
    isAnimating: false,
    showStep: true,
    submitPending: false,
};

export function reducer(state, action) {
    // console.log("Type: ", action.type, action.value || "");

    switch (action.type) {
        case "NEXT_STEP":
            return {
                ...state,
                currentIndex: state.currentIndex + 1,
                isAnimating: true,
                isAnimDirectionForward: true,
                showStep: false,
            };
        case "PREVIOUS_STEP":
            return {
                ...state,
                currentIndex: state.currentIndex - 1,
                isAnimating: true,
                isAnimDirectionForward: false,
                showStep: false,
            };
        case "GO_TO_STEP":
            return {
                ...state,
                currentIndex: action.value,
                isAnimating: true,
                isAnimDirectionForward: action.value > state.currentIndex,
                showStep: false,
            };
        case "STEP_CHANGE_ENDED":
            return {
                ...state,
                isAnimating: false,
                showStep: true,
                submitPending: false,
            };
        case "START_LOADING":
            return {
                ...state,
                submitPending: true,
            };
        case "STOP_LOADING":
            return {
                ...state,
                submitPending: false,
            };
        default:
            throw new Error();
    }
}
